import { RouteInfo } from './sidebar.metadata';
import { titles } from 'src/app/utils/titles';

export const ROUTES: RouteInfo[] = [
    {
        url: '',
        title: titles.personal.titulo,
        moduloID: 0, moduloActive: false,
        icon: 'mdi mdi-dots-horizontal',
        class: 'nav-small-cap',
        extralink: true,
        label: '',
        labelClass: '',
        submenu: []

    },
    {
        url: '',
        title: titles.configuracion.titulo,
        moduloID: 1,
        accesoID: 0,
        moduloActive: false,
        icon: 'fas fa-cogs',
        class: 'has-arrow',
        label: '',
        labelClass: '',
        extralink: false,
        submenu: [

            {
                title: titles.configuracion.options.compania,
                icon: '',
                moduloID: 1,
                accesoID: 1010,
                moduloActive: false,
                url: '/modulo/configuracion/compañia',
                extralink: false,
                class: '',
                label: '',
                labelClass: '',
                submenu: []
            },
            /*
            {
                title: titles.configuracion.options.companiaPublicidad,
                icon: '',
                moduloID: 1,
                accesoID: 1011,
                moduloActive: false,
                url: '/modulo/configuracion/compañia-publicidad',
                extralink: false,
                class: '',
                label: '',
                labelClass: '',
                submenu: []
            }, 
            */
            {
                title: titles.configuracion.options.clasesGenericas,
                icon: '',
                moduloID: 1,
                accesoID: 1012,
                moduloActive: false,
                url: '/modulo/configuracion/clases-genericas',
                extralink: false,
                class: '',
                label: '',
                labelClass: '',
                submenu: []
            },

            {
                title: titles.configuracion.options.archivosSistema,
                icon: '',
                moduloID: 1,
                accesoID: 1013,

                moduloActive: false,
                url: '/modulo/configuracion/archivos-sistema',
                extralink: false,
                class: '',
                label: '',
                labelClass: '',
                submenu: []
            },
            {
                title: 'Contabilidad',
                icon: '',
                moduloID: 1,
                accesoID: 1022,
                moduloActive: false,
                url: '/modulo/configuracion/contabilidad',
                extralink: false,
                class: '',
                label: '',
                labelClass: '',
                submenu: []
            },
            {
                title: titles.configuracion.options.interlocutorComercial,
                icon: '',
                moduloID: 1,
                accesoID: 1014,

                moduloActive: false,
                url: '/modulo/configuracion/interlocutor-comercial',
                extralink: false,
                class: '',
                submenu: []
            },
            {
                title: titles.configuracion.options.articulos,
                icon: '',
                moduloID: 1,
                accesoID: 1015,
                moduloActive: false,
                url: '/modulo/configuracion/articulos',
                extralink: false,
                class: '',
                submenu: []
            },
            {
                title: 'Bancos',
                icon: '',
                moduloID: 1,
                accesoID: 1016,
                moduloActive: false,
                url: '/modulo/configuracion/bancos',
                extralink: false,
                class: '',
                submenu: []
            },
            {
                title: titles.configuracion.options.avisoVencimiento,
                icon: '',
                moduloID: 1,
                accesoID: 1018,
                moduloActive: false,
                url: '/modulo/configuracion/aviso-vencimiento',
                extralink: false,
                class: '',
                submenu: []
            },
            {
                title: titles.configuracion.options.estructuraCertificado,
                icon: '',
                moduloID: 1,
                accesoID: 1019,
                moduloActive: false,
                url: '/modulo/configuracion/estructura-calidad',
                extralink: false,
                class: '',
                submenu: []
            },

            {
                title: titles.configuracion.options.dashboard,
                icon: '',
                moduloID: 1,
                accesoID: 1020,

                moduloActive: false,
                url: '/modulo/configuracion/dashboard',
                extralink: false,
                class: '',
                submenu: []
            },
            {
                title: titles.configuracion.options.columnasFormularios,
                icon: '',
                moduloID: 1,
                accesoID: 1021,

                moduloActive: false,
                url: '/modulo/configuracion/columnas-formulario',
                extralink: false,
                class: '',
                submenu: []
            },
            {
                title: titles.configuracion.options.seguimientoDocumentos,
                icon: '',
                moduloID: 1,
                accesoID: 1021,

                moduloActive: false,
                url: '/modulo/configuracion/seguimiento-documentos',
                extralink: false,
                class: '',
                submenu: []
            },
            {
                title: titles.configuracion.options.configuracionFormulario,
                icon: '',
                moduloID: 1,
                accesoID: 1021,
                moduloActive: false,
                url: '/modulo/configuracion/config-formulario',
                extralink: false,
                class: '',
                submenu: []
            },
        ],
    },

    {
        title: titles.facturacionElectronica.titulo,
        icon: ' fas fa-paper-plane',
        moduloID: 1,
        accesoID: 2,
        moduloActive: false,
        url: '/modulo/configuracion/facturacion-electronica',
        extralink: false,
        class: '',
        submenu: []
    },

    {
        url: '',
        title: titles.administracion.titulo,
        moduloID: 1,
        accesoID: 3,
        moduloActive: false,
        icon: 'fas fa-user-shield',
        class: 'has-arrow',
        label: '3',
        labelClass: 'side-badge badge badge-info',
        extralink: false,
        submenu: [
            {
                title: titles.administracion.options.usuarios,
                moduloID: 16,
                accesoID: 101,
                moduloActive: false,
                icon: '',
                url: '/modulo/administracion/usuarios',
                idcontexto: 2,
                extralink: false,
                class: '',
                isCollapsed: false,
                nombreContexto: 'Administracion',
                submenu: []
            },
            {
                title: 'Usuarios masivo',
                moduloID: 16,
                accesoID: 101,
                moduloActive: false,
                icon: '',
                url: '/modulo/administracion/usuarios-masivo',
                idcontexto: 2,
                extralink: false,
                class: '',
                isCollapsed: false,
                nombreContexto: 'Administracion',
                submenu: []
            },
            {
                title: titles.administracion.options.grupos,
                moduloID: 16,
                accesoID: 101,
                moduloActive: false,
                icon: '',
                url: '/modulo/administracion/grupos',
                idcontexto: 2,
                extralink: false,
                class: '',
                isCollapsed: false,
                nombreContexto: 'Administracion',
                submenu: []
            },
            {
                title: 'Módulos',
                moduloID: 16,
                accesoID: 101,
                moduloActive: false,
                icon: '',
                url: '/modulo/administracion/modulos',
                idcontexto: 2,
                extralink: false,
                class: '',
                isCollapsed: false,
                nombreContexto: 'Administracion',
                submenu: []
            },
            {
                title: 'Permisos',
                moduloID: 16,
                accesoID: 101,
                moduloActive: false,
                icon: '',
                url: '/modulo/administracion/accesos',
                idcontexto: 2,
                extralink: false,
                class: '',
                isCollapsed: false,
                nombreContexto: 'Administracion',
                submenu: []
            },
            {
                title: 'Propiedades',
                moduloID: 16,
                accesoID: 101,
                moduloActive: false,
                icon: '',
                url: '/modulo/administracion/propiedades',
                idcontexto: 2,
                extralink: false,
                class: '',
                isCollapsed: false,
                nombreContexto: 'Administracion',
                submenu: []
            },
            {
                title: 'Mantenimiento de permisos',
                moduloID: 16,
                accesoID: 101,
                moduloActive: false,
                icon: '',
                url: '/modulo/administracion/mantenimiento-permisos',
                idcontexto: 2,
                extralink: false,
                class: '',
                isCollapsed: false,
                nombreContexto: 'Administracion',
                submenu: []
            },
            {
                title: titles.administracion.options.usuariosConectados,
                moduloID: 16,
                accesoID: 101,
                moduloActive: false,
                icon: '',
                url: '/modulo/administracion/usuarios-conectados',
                idcontexto: 2,
                extralink: false,
                class: '',
                isCollapsed: false,
                nombreContexto: 'Administracion',
                submenu: []
            }

            /* ,
        {
            title: 'Control de versiones',
            moduloID: 16,
            accesoID: 101,
            moduloActive: false,
            icon: '',
            url: '/modulo/administracion/control-versiones',
            idcontexto: 2,
            extralink: false,
            class: '',
            isCollapsed: false,
            nombreContexto: 'Administracion',
            submenu: []
        } */],
        nombreContexto: titles.administracion.titulo,
        idcontexto: 2,
    },
    // {
    //     // url: '',
    //     // title: 'Licencias',
    //     // moduloID: 0, moduloActive: false,
    //     // icon: 'mdi mdi-dots-horizontal',
    //     // class: 'nav-small-cap',
    //     // extralink: true,
    //     // label: '',
    //     // labelClass: '',
    //     // submenu: []
    //     url: '/modulo/licencia/licencia',
    //     title: titles.licencias.titulo,
    //     moduloID: 1,
    //     accesoID: 4,
    //     moduloActive: false,
    //     icon: 'fas fa-user-shield',
    //     class: '',
    //     label: '3',
    //     labelClass: 'side-badge badge badge-info',
    //     extralink: false,
    //     submenu: []
    // },
    {
        url: '',
        title: 'API ACG',
        moduloID: 1,
        accesoID: 5,
        moduloActive: false,
        icon: 'fas fa-plug',
        class: 'has-arrow',
        label: '3',
        labelClass: 'side-badge badge badge-info',
        extralink: false,
        submenu: [
            {
                title: 'Config. General',
                moduloID: 1,
                accesoID: 5010,
                moduloActive: false,
                icon: '',
                url: '/modulo/api-acg/mantenimiento-general',
                idcontexto: 2,
                extralink: false,
                class: '',
                isCollapsed: false,
                nombreContexto: 'Administracion',
                submenu: []
            },

            {
                title: 'Config. Inforest, Infohotel',
                moduloID: 1,
                accesoID: 5011,
                moduloActive: false,
                icon: '',
                url: '/modulo/api-acg/mantenimiento-inforest',
                idcontexto: 2,
                extralink: false,
                class: '',
                isCollapsed: false,
                nombreContexto: 'Administracion',
                submenu: []
            },
            {
                title: 'Configurados',
                moduloID: 1,
                accesoID: 5011,
                moduloActive: false,
                icon: '',
                url: '/modulo/api-acg/configurados',
                idcontexto: 2,
                extralink: false,
                class: '',
                isCollapsed: false,
                nombreContexto: 'Administracion',
                submenu: []
            }
        ]
    },
    {
        url: '/modulo/notificaciones',
        title: 'Notificaciones',
        moduloID: 1,
        accesoID: 6,
        moduloActive: false,
        icon: 'fas fa-bell',
        class: '',
        label: '3',
        labelClass: 'side-badge badge badge-info',
        extralink: false,
        submenu: []

    },
    {
        url: '/modulo/gestion-tipo-cambio-maviso',
        title: 'Gestión de T.C. masivo',
        moduloID: 1,
        accesoID: 8,
        moduloActive: false,
        icon: 'fas fa-coins',
        class: '',
        label: '3',
        labelClass: 'side-badge badge badge-info',
        extralink: false,
        submenu: []

    },
    {
        url: '',
        title: titles.versiones.titulo,
        moduloID: 1,
        accesoID: 7,
        moduloActive: false,
        icon: 'icon-link',
        class: '',
        label: '3',
        labelClass: 'side-badge badge badge-info',
        extralink: true,
        submenu: [],
        nombreContexto: 'Administracion',
        idcontexto: 2,
        nombreModulo: 'versiones'
    }

];